import { Alert, Snackbar } from "@mui/material";
import fetch from "auth/FetchInterceptor";
import { API_BASE_URL } from "configs/AppConfig";
import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
// import { useLocation } from "react-router-dom";
import { clearResponseMessage } from "redux/actions/ApiMessageResponse";
import { REQUEST_LANG } from "redux/constants/Lookup";
import { SWRConfig } from "swr";
import Footer from "./component/shared/footer/Footer";
import { I18nProvider } from "./lang";
import Views from "./pages";
import CookieConsentHook from "functions/cookieConsent";
// import ChatBot from "./component/chatbot";

const ContainerLayout = () => {
  const dir = useSelector(({ theme }) => theme.direction);
  // const location = useLocation();
  // const isSharedChatPage = location.pathname.startsWith("/share/");
  const { showMessage, message, messageType } = useSelector(
    ({ apiMessageResponse }) => apiMessageResponse
  );
  const dispatch = useDispatch();
  const initRef = useRef(false);
  useEffect(() => {
    if (initRef.current === false) {
      dispatch({ type: REQUEST_LANG });
      initRef.current = true;
    }
  }, []);
  const onNotificationClose = () => {
    dispatch(clearResponseMessage());
  };
  return (
    <div dir={dir}>
      <I18nProvider>
        <SWRConfig
          value={{
            fetcher: ({ url, params }) => {
              if (url.includes("http")) {
                return fetch.get(`${url}`, { params }).then((r) => r);
              } else {
                return fetch
                  .get(`${API_BASE_URL}/${url}`, { params })
                  .then((r) => r);
              }
            },
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            refreshWhenHidden: false,
            refreshInterval: 0,
            shouldRetryOnError: false,
          }}
        >
          {messageType && (
            <Snackbar
              open={showMessage}
              autoHideDuration={5000}
              onClose={onNotificationClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
            >
              <Alert
                onClose={onNotificationClose}
                severity={messageType}
                variant="filled"
                sx={{ width: "100%" }}
              >
                {message}
              </Alert>
            </Snackbar>
          )}
          <Views />
          <Footer />
          {/* {!isSharedChatPage && <ChatBot />} */}
          <CookieConsentHook />
        </SWRConfig>
      </I18nProvider>
    </div>
  );
};

export default ContainerLayout;
